import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CoachingStatus } from '../../../graphQL';
import { getRoute } from '../../../routes';
import { useCoachingContext } from '../context/coachingContext';

export const useCoachingRedirectToOnboarding = (): void => {
  const navigate = useNavigate();

  const { coachingStatus } = useCoachingContext();

  useEffect(() => {
    if (coachingStatus === undefined) {
      // The coaching status has not loaded yet.
      return;
    }

    // If they are onboarding, redirect them to coaching onboarding.
    if (coachingStatus === CoachingStatus.Onboarding) {
      navigate(getRoute('coachingOnboarding', {}), { replace: true });
    }
  }, [coachingStatus]);
};
